export const educationData = [
    {
        id: 1,
        institution: 'Kanunga High School, Kiambu',
        course: 'KCSE',
        startYear: '2014',
        endYear: '2017'
    },
    {
        id: 2,
        institution: 'Moi University, Uasin Gishu County',
        course: 'Bachelor of Computer Science',
        startYear: '2018',
        endYear: '2023',
        description: 'Second Class Honors (Upper Division). High grades in AI (A-), Algorithms (A), Data Structures, and Software Engineering.'
    },
]